"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRequestInterceptor = defaultRequestInterceptor;
exports.defaultResponseInterceptor = defaultResponseInterceptor;
exports.defaultErrorInterceptor = defaultErrorInterceptor;
exports.ResponseError = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * 
 * @param obj 对象
 * @param values 去掉对象里值为该数组的里的值的部分
 * 
 * eg: 
 *  omitSpecValue({ a: 1, b: undefined }, [undefined]) => { a: 1 }
 */


function omitSpecValue(obj) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).filter(function (key) {
    return values.indexOf(obj[key]) === -1;
  }).reduce(function (acc, cur) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, obj[cur]));
  }, {});
}
/**
 * TODO 这个是快站专用的 
 * 开源还需另外考虑
 * @param config 
 */


function defaultRequestInterceptor(config) {
  var url = config.url,
      _config$payload = config.payload,
      payload = _config$payload === void 0 ? {} : _config$payload,
      method = config.method,
      _config$headers = config.headers,
      headers = _config$headers === void 0 ? {} : _config$headers,
      baseUrl = config.baseUrl;

  var _headers = _objectSpread({}, headers);

  if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
    // default json
    _headers['content-type'] = 'application/json';
  } // concat baseUrl


  var _url = baseUrl + url; // omit [undefined, null] value


  var _payload = omitSpecValue(payload, undefined, null); // 自行拼GET请求的url, 以适应后端对于x=0&x=1的格式 { x: [0, 1] } => x=0&x=1


  if (method === 'GET') {
    _url = Object.keys(_payload).reduce(function (acc, cur) {
      return acc + (Array.isArray(_payload[cur]) ? _payload[cur].reduce(function (_acc, _cur) {
        return _acc + "".concat(cur, "=").concat(encodeURIComponent(_cur), "&");
      }, '') : "".concat(cur, "=").concat(encodeURIComponent(_payload[cur]), "&"));
    }, _url + '?');
    _url = _url.slice(0, -1);
    _payload = undefined;
  } // debugger


  return _objectSpread(_objectSpread({}, config), {}, {
    headers: _headers,
    payload: _payload,
    url: _url
  });
}

var ResponseError = /*#__PURE__*/function (_Error) {
  _inherits(ResponseError, _Error);

  var _super = _createSuper(ResponseError);

  function ResponseError(status, message) {
    var _this;

    _classCallCheck(this, ResponseError);

    _this = _super.call(this, message);
    _this.status = status;
    _this.status = status;
    return _this;
  }

  return ResponseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ResponseError = ResponseError;

function defaultResponseInterceptor(response) {
  if (response.status > 300 || response.status < 100) {
    return Promise.reject(new ResponseError(response.status, "request bad, status: ".concat(response.status)));
  }

  return response;
}
/**
 * 
 * @param config 
 */


function defaultErrorInterceptor(error) {
  return Promise.reject(error);
}